import ActionTypes from "../constants";
import * as api from '../api/index';
import Swal from 'sweetalert2';
import Toast from "../components/Toast";


export const loginUser = (data) => async (dispatch) => {
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.login(data).then(res => {
        if (JSON.parse(res).status == 200) {
            localStorage.setItem('user', JSON.stringify(JSON.parse(res).data));
            localStorage.setItem('user_token', JSON.stringify(JSON.parse(res).user_token));
            localStorage.setItem('perm', JSON.stringify(JSON.parse(res).permissions));
            localStorage.setItem('user_name', JSON.stringify(JSON.parse(res).user_name));
            dispatch({
                type: ActionTypes.LOGINREQUESTSUCCESS,
                payload: JSON.parse(res),
            });
            // 'data', JSON.parse(res).user_token);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Login Successful!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            if (JSON.parse(res).status == 400 && !JSON.parse(res).message) {
                Toast.fire({
                    icon: 'error',
                    title: Object.values(JSON.parse(res).errors)[0][0]
                })
            } else if (JSON.parse(res).status == 400 && JSON.parse(res).message) {
                Toast.fire({
                    icon: 'error',
                    title: JSON.parse(res).message
                })
            }
            else if (JSON.parse(res).title == undefined) {
                Toast.fire({
                    icon: 'error',
                    title: 'Email or Password is incorrect.'
                })
            } else if (JSON.parse(res).title == 'Unauthorized') {
                Toast.fire({
                    icon: 'error',
                    title: 'Email or Password is incorrect.'
                })
            } else {
                Toast.fire({
                    icon: 'error',
                    title: Object.values(JSON.parse(res).errors)[0][0]
                })
            }
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.LOGINREQUESTFAILED,
            payload: err,
        });
        dispatch({
            type: ActionTypes.LOADING,
            payload: false,
        });
    })
}

export const logoutIndex = () => async (dispatch) => {
    // 'logout index')
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    localStorage.removeItem('user');
    localStorage.removeItem('perm');
    localStorage.removeItem('user_token');
    dispatch({
        type: ActionTypes.LOGOUT
    });
    Toast.fire({
        icon: 'success',
        title: 'Logout Successful!'
    });
    dispatch({
        type: ActionTypes.LOADING,
        payload: false,
    });
}